// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","561":"slideshow"}[chunkId] + "." + {"18":"42ff319d","561":"e628f381"}[chunkId] + ".css";
};